import React from 'react';

const BassClef = props => (
   <svg
      className="clef bass"
      width="35"
      height="65"
      viewBox="0 0 683.61717 1523.3183"
   >
        <title>Bass Clef</title>   
    <g transform="matrix(0.07781866,0,0,0.07781866,21.529094,265.78191)">
         <g transform="matrix(4.588483,0,0,4.575039,-4898.431,-28736.72)"><path
            className="fil0 str0"
            d="M 984,7559 H 2953"
            id="path9-0"
         /><path
               className="fil0 str0"
               d="M 984,8740 H 2953"
               id="path11-6"
            /><path
               className="fil0 str0"
               d="M 984,8149 H 2953"
               id="path13-1"
            /><path
               className="fil0 str0"
               d="M 984,6968 H 2953"
               id="path15-7"
            /><path
               className="fil0 str0"
               d="M 984,6378 H 2953"
               id="path17-0"
            /><path
               className="fil1 str1"
               d="m 1239,8245 c 158,-107 276,-188 352,-244 76,-55 156,-124 238,-206 82,-82 151,-175 207,-278 44,-76 82,-164 113,-264 31,-99 47,-195 50,-286 0,-85 -11,-166 -34,-242 -22,-77 -60,-140 -114,-191 -54,-50 -124,-75 -211,-75 -84,0 -163,17 -237,50 -73,34 -125,88 -154,164 0,7 -4,16 -10,29 2,16 10,28 25,37 15,9 28,13 40,13 6,0 23,-3 49,-9 27,-6 49,-10 67,-10 53,0 100,19 143,56 42,37 63,82 63,135 0,38 -11,74 -32,107 -21,33 -50,60 -87,79 -37,20 -78,29 -122,29 -80,0 -148,-24 -204,-73 -55,-50 -83,-113 -83,-192 0,-101 31,-188 92,-262 62,-74 140,-129 236,-166 95,-38 191,-56 289,-56 107,0 209,27 304,82 96,54 171,129 227,222 56,94 85,194 85,302 0,192 -64,370 -192,535 -128,165 -286,308 -475,430 -126,83 -330,195 -611,336 z M 2628,6698 c 0,-36 13,-66 39,-90 25,-25 56,-37 93,-37 32,0 62,14 89,41 27,26 40,57 40,91 0,36 -14,67 -40,92 -28,24 -59,36 -94,36 -37,0 -67,-12 -91,-39 -24,-26 -36,-57 -36,-94 z m 0,524 c 0,-36 13,-67 37,-91 25,-25 56,-37 95,-37 32,0 61,13 89,40 26,27 40,56 40,88 0,39 -13,70 -38,95 -26,25 -56,38 -91,38 -39,0 -70,-13 -95,-37 -24,-24 -37,-56 -37,-96 z"
               id="path19-1"
            />
         </g>
      </g>
   </svg >
);

export default BassClef;